<template>
    <div class="report-result" :class="{'strong-report-result': resultType == 'strong'}">
        <div v-if="resultType == 'strong'" class="report-result-top-title">科学大数据智能评测</div>
        <div v-if="resultType == 'strong'" class="report-result-info">
            <p class="info-red">封建迷信：宿命论，八字定富贵<i class="iconbg icon-report-ji"></i></p>
            <p class="info-green">科普真相：通过数百万的案例反馈我们知道，八字只是描述了先天的人生轨迹，通过后天的选择及努力，我们可以将人生这道计算题找到最优解<i class="iconbg icon-report-yi"></i></p>
            <p>生辰八字属于概率学，虽不可能百分之百准确，但因积累数千年，其中的智慧依然会给每个人带来巨大参考价值，绝不是供娱乐而用。</p>
            <p>比如我们选择适合我们即喜用的颜色、方向或生肖无论是心理上还是物理能量上都会给我们的运势有加分作用，选错了则适得其反。具体还需以实践感受验证为准。</p>
            <p>如何趋吉避凶？</p>
            <p>一、无论是我们的事业还是家庭好坏，跟我们的性格有着紧密关系，因此，知己知彼，系统、充分地认知自己，知道自己的天赋所在，扬长避短，才可能趋吉避凶。</p>
        </div>
        <!-- <van-index-bar class="van-index-bar-report-result" :class="'van-index-bar'+reportResultBarIndex" :index-list="reportResultBarList" @select="onReportBarSelected"> -->
        <!-- <van-index-anchor class="van-index-anchor-report-result" index="性格天赋" /> -->
        <div v-if="resultType == 'report'" class="report-result-content-title">
            <p class="info-red">如何趋吉避凶？阅读原理科普及趋吉指南必有收获。</p>
            <p class="info-green"><span>如果是给他人做指导，按以下步骤顺序进行效果更佳</span></p>
            <p>一、无论是我们的事业还是家庭好坏，跟我们的性格有着紧密关系，因此，知己知彼，系统、充分地认知自己，知道自己的天赋所在，扬长避短，才可能趋吉避凶。</p>
        </div>
        <!-- 1、性格天赋解析 -->
        <div class="report-result-content-outbox" id="characterBox">
            <div class="report-result-content">
                <div class="report-result-title">{{ (reportAIData.talent && reportAIData.talent.needpay == 0) || reportAIData.describe_short ? '性格天赋解析' : '性格解析'}}</div>
                <div class="report-result-content-b1">
                    <div class="report-result-content-b2">
                        <div class="report-result-main-content">
                            <!-- 1.1 性格部分:pay_10000 -->
                            <p class="report-p-blue">性格特征为必须验证项，<span class="report-p-red">如果多数相符，说明生日信息无误，可以继续后面的测评</span>，否则建议确认好生日信息再继续，注意生日信息以实际出生地的时间为准，不要以身份证为准。</p>
                            <!-- 未解锁 -->
                            <div v-if="reportData['pay_10000'] == 0" class="report-result-content-fuzzy-1" :class="payFailedStatus['pay_10000'] ? 'fuzzy-long' : ''">
                                <div v-if="reportProductData['pay_10000']" class="report-result-button report-result-button-posab">
                                    <div v-if="aiConfigData.freeTimes > 0" class="report-result-note">您有<span class="number">{{aiConfigData.freeTimes}}</span>张性格测评免费解锁券</div>
                                    <report-button
                                        v-bind:buttonType="'2'"
                                        v-bind:reportData="reportProductData['pay_10000']"
                                        v-bind:freeBtn="aiConfigData.freeTimes > 0 || showFreeCharacter"
                                        v-bind:vipBtn="!showFreeCharacter && userData && parseInt(userData.vip) > 10"
                                        v-bind:clickFunc="clickPay">
                                    </report-button>
                                    <p v-if="aiConfigData.freeTimes == 0 || showFreeCharacter" class="report-result-button-note note-red">专属优惠价，原价<del>{{reportProductData['pay_10000'].rate_price}}</del>元 已有{{reportProductData['pay_10000'].sold}}人购买</p>
                                </div>
                            </div>
                            <!-- 已解锁 -->
                            <div v-else class="report-result-ct-content">
                                <p :class="{'report-result-ct-p-pad': describeData.indexOf('外在性格：') != -1 || describeData.indexOf('内在性格：') != -1}" v-for="describeData in reportAIData.describe" v-bind:key="describeData + Math.random(0, 10)" v-html="UTILS.getReportCharacter(describeData)"></p>
                                <div class="report-result-mc-content">
                                    <div class="report-result-mc-title"><span class="blue">注意误区</span></div>
                                    <div class="report-result-mc-info">
                                        平时大家容易把农历和阳历生日搞混或者以身份证信息而非实际生日为准，所以实际上八字可能是错的；另外，错的八字给人看也可能正好对上某些事件，不同理派的看法可能不一样，但因为江湖先生第六感够强，也能命中一些事件，但唯独经过性格的全面验证才能保证八字对应的生日信息是正确的，这是经过无数理派大数据论证后最准确靠谱的方法，没有之一。大家如要找人工测算，也可以让对方先给验证八字对应的先天出生性格。
                                    </div>
                                </div>
                            </div>
                            <!-- 1.2 天赋部分:pay_31100 -->
                            <div class="report-result-mc-content-title border-top">
                                天下相同八字的人数不胜数，但是他们的人生成就及财富水平高低各不相同。为什么？因为就算命运轨迹相似，选择从事的行业或者方向不同很大程度导致了人生成就的大相径庭。所以，搞清楚自己的天赋是什么，适合做什么就显得尤为重要了，不以自身短板拼人家长处。
                            </div>
                            <!-- 未解锁 -->
                            <div v-if="reportData['pay_31100'] == 0" class="report-result-content-fuzzy-2" :class="payFailedStatus['pay_31100'] ? 'fuzzy-long' : ''">
                                <div v-if="talentProductData['pay_31100']" class="report-result-button report-result-button-posab">
                                    <report-button
                                        v-bind:buttonType="'22'"
                                        v-bind:buttonText="'解锁个人天赋矩阵及适合职业'"
                                        v-bind:reportData="talentProductData['pay_31100']"
                                        v-bind:freeBtn="false"
                                        v-bind:vipBtn="userData && parseInt(userData.vip) > 10"
                                        v-bind:clickFunc="clickPay">
                                    </report-button>
                                    <p class="report-result-button-note note-red">专属优惠价，原价<del>{{talentProductData['pay_31100'].rate_price}}</del>元 已有{{talentProductData['pay_31100'].sold}}人购买</p>
                                    <p class="report-result-button-note note-green">此部分报告约500字</p>
                                </div>
                            </div>
                            <!-- 已解锁 -->
                            <nature-talent v-else :resultType="resultType" class="report-nature-content-box"></nature-talent>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 一键解锁按钮:解锁全部:pay_10005 -->
        <!-- 全部都解锁之后隐藏按钮 -->
        <div id="allButtonBox" class="report-result-button report-result-button-1" v-if="(reportData[productList[1]] == 0 || reportData[productList[2]] == 0 || reportData[productList[3]] == 0 || reportData[productList[4]] == 0) && reportData[productList[5]] == 0 && productData[productList[5]]">
            <report-button 
                v-bind:buttonType="'1'"
                v-bind:buttonText="'解锁以下运势报告'"
                v-bind:reportData="reportProductData['pay_10005']"
                v-bind:vipBtn="userData && parseInt(userData.vip) > 10"
                v-bind:clickFunc="clickPay">
            </report-button>
            <p class="report-result-button-note">专属优惠价，原价<del>{{reportProductData['pay_10005'].rate_price}}</del>元 已有{{reportProductData['pay_10005'].sold}}人购买</p>
        </div>

        <!-- <van-index-anchor class="van-index-anchor-report-result" index="财富提升" /> -->
        <div id="titleBox1" class="report-result-content-title report-result-content-title-3">
            <p>二、厚德载物，格局和时运决定我们一生能承载多少财富，大家经常找人算这项，但是大数据在此为我们揭晓真正的原理是什么。为每个人的格局提供提升方向，千金难买的箴言，望君切记。</p>
        </div>
        <!-- 2、提升人生财富水平的建议:pay_10002 -->
        <div class="report-result-content-outbox" id="wealthBox">
            <div class="report-result-content">
                <div class="report-result-title title-long">提升人生财富格局及趋吉的方法</div>
                <div class="report-result-content-b1">
                    <div class="report-result-content-b2">
                        <p class="report-p-blue">越想赚钱的人越赚不到钱，越不想赚钱的人越赚得到钱，这背后到底是什么原理？五行我到底喜什么？适合在什么方位工作生活，适合与什么生肖合作，忌讳什么？</p>
                        <!-- 6.3 解锁按钮:解锁建议:2 -->
                        <div v-if="reportData['pay_10002'] == 0" class="report-result-content-fuzzy-3" :class="payFailedStatus['pay_10002'] ? 'fuzzy-long' : ''">
                            <div v-if="reportProductData['pay_10002']" class="report-result-button report-result-button-posab">
                                <report-button
                                    v-bind:buttonType="'2'"
                                    v-bind:reportData="reportProductData['pay_10002']"
                                    v-bind:vipBtn="userData && parseInt(userData.vip) > 10"
                                    v-bind:clickFunc="clickPay">
                                </report-button>
                                <p class="report-result-button-note note-red">专属优惠价，原价<del>{{reportProductData['pay_10002'].rate_price}}</del>元 已有{{reportProductData['pay_10002'].sold}}人购买</p>
                                <p class="report-result-button-note note-green">此部分报告约500字+</p>
                            </div>
                        </div>
                        <div v-else-if="reportData['pay_10002'] == -1" class="report-result-content-no-result">
                            <p>出生时间超出智能测算时间范围，</p>
                            <p>不能进行此项测算。</p>
                        </div>
                        <div v-else class="report-result-ct-content">
                            <report-info v-if="resultType != 'strong'"></report-info>
                            <p class="nature-c-paragraph p-ral p-blank"><span class="report-green-title">针对性建议：</span></p>
                            <p v-for="suggestData in reportAIData.suggest" v-bind:key="suggestData + Math.random(0, 10)"  class="">{{suggestData}}</p>
                            <!-- 五行能量部分 -->
                            <div class="report-result-mc-content">
                                <!-- 常识误区 -->
                                <div class="report-result-mc-title"><span class="blue">常识误区</span></div>
                                <div class="report-result-mc-info ">
                                    五行缺失，但不代表需要加强，而代表该五行对应的一些天赋能力的缺失，从根本上需要从后天练习来补充。通过佩戴相关颜色或手饰虽然治标不治本但也能起到一定的加分加成作用，考虑到配合运势的助力，建议大家优先选择所喜五行，而不是所缺的五行。
                                </div>
                                <!-- 科普真相 -->
                                <div class="report-result-mc-title"><span class="blue">科普真相</span></div>
                                <div class="report-result-mc-info ">
                                    <p>关于通过八字看财富级别：大数据告诉我们相同八字的人那么多，不同时代不同地区财富级别都不一样，所以本身就是个伪命题；但是我们通过搞清楚下面这些自然原理，搞清楚自己的喜忌方向以及个人格局注意提升的核心，通过后天努力是会让自己的财富更好地发生质变的，好运时借力打力，差运时克制规避，就会使得自己财富也好，成就也好，健康持续。</p>
                                    <p>如果你是在好运中，但取得的结果却不满意，那需要审视一下是否选择了错的努力方向，选错了事业，甚至选错了合作对象(合作方时运不济或者八字相冲等等)。</p>
                                    <p>如果你在差运中，但却取得不错的结果，那要恭喜你，是属于逆境出英才的一类人。可以好好总结一下这么些年获得成果的关键因素，继续巩固自身努力的部分，待到天时地利人和，人生成就及财富将会更上一层楼。</p>
                                </div>
                                <!-- 科普规律 -->
                                <div class="report-result-mc-title"><span class="blue">科普规律</span></div>
                                <div class="report-result-mc-info ">
                                    <p><span class="green2">经过数千年的案例复盘，我们看到每个人的成功都归因于四个字：德位时运。</span>天下所有人的成功都离不开时运，如果一个人无德，他也有可能成功，但是他的成功会因为时运的离去而瓦解。历史上如此闹得身败名裂、家破人亡的大有人在；如果一个人有厚德，但还未成功，那我们知道他的成功只需假以时日必有功成名就之时，就看他能不能沉得住气，保持初心。</p>
                                    <div class="report-result-mc-info-img img-1"></div>
                                    <p>什么是德？历史和现代科学的能量守恒告诉我们，德是我们存在于天地间看不见的支撑能量，我们为世界带来什么，贡献什么，让周围的人得到什么，我们就有多少德。没有时运，能够承载多少名望、财富、地位的就是靠一个人的德行。所以纵观历史千古，凡有大成且能延续长久之人都很重视德行。</p>
                                    <p>积善修德非一日之功，纯粹的利他之心，知行合一是最有效的方式。</p>
                                </div>
                                <!-- 小心骗局 -->
                                <div class="report-result-mc-title"><span class="blue">小心骗局</span></div>
                                <div class="report-result-mc-info ">
                                    <p>帮助趋吉避凶这个地方是江湖算命设陷最多的地方，不要指望找人化解，尤其是使用所谓的法术符咒、能量水晶化解的方式。试想，如果有这样的人，这种人所在的国家早就世界第一了，这些人早就无所不能，富可敌国，也就不用出来施法行骗了。传统命理师可能会用恫吓的方式来骗取进一步的操作，其实，人都来自同一个世界，虽有个体差异，但不至于有如此差距，对方如果有化解的能耐，自己早就不靠算命谋生了，所以千万别被人吓住了。毕竟已经是科学时代了，牛神鬼神的可能性已经被时代验证了，千万不要自己吓自己。</p>
                                    <p>也不要总找人算命，十个命师会有十种说法，算得多自己越迷糊，现在算命行业混乱，胡说八道的大有人在，其实所有算出来的内容都只能做参考。</p>
                                    <p>在好运时，我们需要更多一些敬畏和低调，多积善积德，这样好运过去后我们才会更好承载好运带来的红利；</p>
                                    <p>在差运时，我们也不要自叹自卑，世界是公平的，天地不仁以万物为刍狗，所有人都有好运差运之时，如果现在身处差运逆境中，更加需要磨炼心志，提升技能，厚积薄发，只要能看到未来希望，人生就有发迹之时。这是铁律，千古未变！</p>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
        
        <!-- <van-index-anchor class="van-index-anchor-report-result" index="未来12月运" /> -->
        <div id="titleBox2" class="report-result-content-title report-result-content-title-3">
            <p>三、知命运轨迹，改变人生选择，最终才能成就我们的辉煌人生。</p>
            <p>1、着眼未来12个月,尽早规划顺势而为大展鸿图</p>
            <p class="green2">趋吉方法：在好运的时候，我们可以尽情施展拳脚，但依然对自然界心存敬畏，做有益于他人的事情，定能厚道载物，好运绵长。如遇差运，克制贪婪，加强学习、厚积薄发也可能逆转乾坤。</p>
        </div>
        <!-- 3、未来12个月财运趋势:pay_10001 -->
        <div class="report-result-content-outbox" id="twelveBox">
            <div class="report-result-content">
                <div class="report-result-title">未来12个月月运趋势</div>
                <div class="report-result-content-b1">
                    <div class="report-result-content-b2">
                        <!-- 6.2 解锁按钮:解锁12个月财运:1 -->
                        <div v-if="reportData['pay_10001'] == 0" class="report-result-content-fuzzy-4" :class="payFailedStatus['pay_10001'] ? 'fuzzy-long' : ''">
                            <div v-if="reportProductData['pay_10001']" class="report-result-button report-result-button-posab">
                                <report-button
                                    v-bind:buttonType="'2'"
                                    v-bind:reportData="reportProductData['pay_10001']"
                                    v-bind:vipBtn="userData && parseInt(userData.vip) > 10"
                                    v-bind:clickFunc="clickPay">
                                </report-button>
                                <p class="report-result-button-note note-red">专属优惠价，原价<del>{{reportProductData['pay_10001'].rate_price}}</del>元 已有{{reportProductData['pay_10001'].sold}}人购买</p>
                                <p class="report-result-button-note note-green">此部分报告约1500字+，建议先通读，再每月月前回顾</p>
                            </div>
                        </div>
                        <div v-if="reportData['pay_10001'] == -1" class="report-result-content-no-result">
                            <p>出生时间超出智能测算时间范围，</p>
                            <p>不能进行此项测算。</p>
                        </div>
                        <!-- 数据表 -->
                        <report-re-pay-bar class="mag-t-1" v-if="resultType != 'strong' && reportAIData.month && reportAIData.month.msg && reportAIData.month.x && reportAIData.month.y"
                            :lastTime="reportAIData.month.lastTime" :productData="reportProductData['pay_10001']">
                        </report-re-pay-bar>
                        <report-data-area-new v-if="reportAIData.month && reportAIData.month.x && reportAIData.month.y" 
                            v-bind:canvasId="'dataAreaMonth'"
                            v-bind:curTimeIndex="reportAIData.month.curIndex"
                            v-bind:xDataArr="reportAIData.month.x_new"
                            v-bind:yDataArr="reportAIData.month.y"
                            v-bind:levArr="reportAIData.month.lev_new"
                            v-bind:clickFunc="clickReportMonthDataFunc">
                        </report-data-area-new>
                        <!-- description_new -->
                        <div v-if="reportAIData.month && reportAIData.month.description_new" class="report-result-detail">
                            <div class="report-result-detail-info">
                                <p>点击月份可按月查看解析<span class="info-span" @click="updateMonthContent">{{ reportMonthShowAll ? '收起所有内容' : '展开所有内容' }}</span></p>
                            </div>
                            <div class="report-result-detail-month" v-for="monthData in reportMonthDataList">
                                <div class="report-result-detail-month-title">
                                    <span class="report-green-title">{{ monthData.title }}</span>
                                </div>
                                <p><span class="report-p-blue">总论：</span>{{ monthData.msg.base }}</p>
                                <p><span class="report-p-blue">工作方面：</span>{{ monthData.msg.work }}</p>
                                <p><span class="report-p-blue">人际关系：</span>{{ monthData.msg.people }}</p>
                                <p><span class="report-p-blue">财运方面：</span>{{ monthData.msg.luck }}</p>
                                <p><span class="report-p-blue">建议方面：</span>{{ monthData.msg.suggest }}</p>
                            </div>
                        </div>
                        <div v-else-if="reportAIData.month && reportAIData.month.msg" class="report-result-detail">
                            <p>{{reportAIData.month.msg}}</p>
                            <p>其中<span class="span-b report-p-blue">{{reportAIData.month.maxTips}}</span>将是未来12个月中财运最好的月份，务必抓住机会哦。<span class="span-b" v-if="reportAIData.month.max">其中财运最旺在<span class="span-b report-p-blue">{{reportAIData.month.max}}</span>月发生。</span> 要提升财运把握能力，请看前面的提升建议。</p>
                            <p class="report-p-blue">以上智能测算结果仅供参考，无论财运如何，投资决策都须谨慎！财运好的时候也需要自己努力争取，谨慎决策，重要的事情说多遍！</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div id="titleBox3" class="report-result-content-title report-result-content-title-3">
            <!-- 科普原理 -->
            <div class="report-result-mc-title"><span class="blue">科普原理</span></div>
            <div class="report-result-mc-info ">
                <p>人的运势起伏是人从出生那天根据天体运行相对位置产生的能量作用计算而成；只要我们生活在地球上我们就无从改变它的计算规则；但是我们可以改变输入的行为参数从而改变结果，做到古人希望的趋吉避凶。所以，相同八字的人虽然很多，但是通过后天的努力达成的财富及社会地位相差甚远；如果说这是一道计算题，那么它一定会有最优解。有的人在不好的运里也能有所成就，就是因为首先规避了风险，然后找到了逆转的方向或方法。</p>
            </div>
            <!-- 趋吉方法 -->
            <div class="report-result-mc-title"><span class="blue">趋吉方法</span></div>
            <div class="report-result-mc-info ">
                <p>如果系统显示为逆境的时间段，一定要注意避免贪心、欲望带来的风险，克制为主，多调研，降低做事风险的可能；克服了风险是有可能翻盘拿到更好结果的。如果系统显示为吉的时间段，就是我们说的顺境，做事容易成功，但是要注意财不外露，不要沾沾自喜逢人便说，低声发大财即可，多做积善积德之事更佳。人生好似马拉松长跑，不在于一朝一夕的成功，而在于能否善始善终，健康幸福。</p>
            </div>
            <!-- <van-index-anchor class="van-index-anchor-report-result" index="未来5年运" /> -->
            <p>2、放眼未来5年，知道何时发力，何时蛰伏，按年步步为营做好阶段性规划，应对利好或者利坏时机。</p>
            <p class="green2">趋吉方法：在差运的时候，我们特别要注意修炼内功，广积粮、高筑墙，加强学习，调整好心态静待转运。如果在好运上，财不外露，切勿高调张扬。</p>
        </div>
        <!-- 4、未来五年财运趋势:pay_10003 -->
        <div class="report-result-content-outbox"  id="fiveBox">
            <div class="report-result-content">
                <div class="report-result-title">未来5年个人运势</div>
                <div class="report-result-content-b1">
                    <div class="report-result-content-b2">
                        <!-- 6.4 解锁按钮:解锁未来五年财运趋势:3 -->
                        <div v-if="reportData['pay_10003'] == 0" class="report-result-content-fuzzy-5" :class="payFailedStatus['pay_10003'] ? 'fuzzy-long' : ''">
                            <div v-if="reportProductData['pay_10003']" class="report-result-button report-result-button-posab">
                                <report-button
                                    v-bind:buttonType="'2'"
                                    v-bind:reportData="reportProductData['pay_10003']"
                                    v-bind:vipBtn="userData && parseInt(userData.vip) > 10"
                                    v-bind:clickFunc="clickPay">
                                </report-button>
                                <p class="report-result-button-note note-red">专属优惠价，原价<del>{{reportProductData['pay_10003'].rate_price}}</del>元 已有{{reportProductData['pay_10003'].sold}}人购买</p>
                                <p class="report-result-button-note note-green">此部分报告约500字+，建议先通读，再每年年前回顾</p>
                            </div>
                        </div>
                        <div v-if="reportData['pay_10003'] == -1" class="report-result-content-no-result">
                            <p>出生时间超出智能测算时间范围，</p>
                            <p>不能进行此项测算。</p>
                        </div>
                        <!-- 数据表 -->
                        <report-re-pay-bar class="mag-t-1" v-if="resultType != 'strong' && reportAIData.five && reportAIData.five.x && reportAIData.five.y"
                            :lastTime="reportAIData.five.lastTime" :productData="reportProductData['pay_10003']">
                        </report-re-pay-bar>
                        <report-data-area-new v-if="reportAIData.five && reportAIData.five.x && reportAIData.five.y" 
                            v-bind:canvasId="'dataAreaFive'"
                            v-bind:curTimeIndex="reportAIData.five.curIndex"
                            v-bind:xDataArr="reportAIData.five.x_new"
                            v-bind:yDataArr="reportAIData.five.y"
                            v-bind:levArr="reportAIData.five.lev_new">
                        </report-data-area-new>
                        <div v-if="reportAIData.five" class="report-result-ct-content report-result-detail">
                            <p v-if="reportAIData.five.msg" class="report-p-blue">大数据说话：时运好坏结果是受岁(年)运(大运)同功的综合作用影响，所以在好的大运，就算流年是逆境，只要行为得当也无伤大雅。</p>
                            <p v-for="(fiveData, key, index) in reportAIData.five.msg" v-bind:key="key + Math.random(0, 10)"  class="report-result-ct-p-pad">
                                <span class="green-title">{{reportAIData.five.age ? (key + '年 ' + reportAIData.five.age[index] + '岁'): (key + '年')}}</span>
                                <span v-html="UTILS.getBreakLineByText(fiveData)"></span>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- <van-index-anchor class="van-index-anchor-report-result" index="总运程" /> -->
        <div id="titleBox4" class="report-result-content-title report-result-content-title-3">
            <p>3、获悉人生总体运势轨迹，提前谋局规划能帮助调整心态，更好经营人生，做到心中有数，处变不惊。</p>
            <p class="green2">趋吉方法：如果你过往经历了好运，但尚未取得满意结果，那需要思考是不是走错了人生方向，选错了领域，或者到错了地域，请参考第一、二步测评报告；如果你在差运中取得还不错的结果，那么恭喜你，未来空间更值得期待，需要思考怎么回报社会，进而会回馈得到更大人生成就或财富，世界是能量守恒的。</p>
        </div>
        <!-- 5、人生财运总趋势:pay_10004 -->
        <div class="report-result-content" id="lifeLuckBox">
            <div class="report-result-title">人生运程总趋势</div>
            <div class="report-result-content-b1">
                <div class="report-result-content-b2">
                    <!-- 6.5 解锁按钮:解锁人生财运总趋势:4 -->
                    <div v-if="reportData['pay_10004'] == 0" class="report-result-content-fuzzy-6" :class="payFailedStatus['pay_10004'] ? 'fuzzy-long' : ''">
                        <div v-if="reportProductData['pay_10004']" class="report-result-button report-result-button-posab">
                            <report-button
                                v-bind:buttonType="'2'"
                                v-bind:reportData="reportProductData['pay_10004']"
                                v-bind:vipBtn="userData && parseInt(userData.vip) > 10"
                                v-bind:clickFunc="clickPay">
                            </report-button>
                            <p class="report-result-button-note note-red">专属优惠价，原价<del>{{reportProductData['pay_10004'].rate_price}}</del>元 已有{{reportProductData['pay_10004'].sold}}人购买</p>
                            <p class="report-result-button-note note-green">建议先通读，再每十年一个回顾</p>
                        </div>
                    </div>
                    <div v-if="reportData['pay_10004'] == -1" class="report-result-content-no-result">
                        <p>出生时间超出智能测算时间范围，</p>
                        <p>不能进行此项测算。</p>
                    </div>
                    <!-- 数据表 -->
                    <report-re-pay-bar class="mag-t-1" v-if="resultType != 'strong' && reportAIData.all && reportAIData.all.msg && reportAIData.all.x && reportAIData.all.y"
                        :lastTime="reportAIData.all.lastTime" :productData="reportProductData['pay_10004']">
                    </report-re-pay-bar>
                    <report-data-area-new v-if="reportAIData.all && reportAIData.all.x && reportAIData.all.y" 
                        v-bind:canvasId="'dataAreaAll'"
                        v-bind:curTimeIndex="reportAIData.all.curIndex"
                        v-bind:xDataArr="reportAIData.all.x_new"
                        v-bind:yDataArr="reportAIData.all.y"
                        v-bind:levArr="reportAIData.all.lev_new">
                    </report-data-area-new>
                    <div v-if="reportAIData.all && reportAIData.all.msg" class="report-result-ct-content report-result-detail">
                        <p v-if="reportAIData.all.msg" class="report-p-blue">大数据说话：时运好坏结果是受岁(年)运(大运)同功的综合作用影响，所以就算是大运在逆境，也能依靠流年的努力逆转乾坤。</p>
                        <p v-for="(allData, key, index) in reportAIData.all.msg" v-bind:key="key + Math.random(0, 10)"  class="report-result-ct-p-pad">
                            <span class="green-title">{{reportAIData.all.age ? (key + '-'+(parseInt(key)+9)+ '年(' + reportAIData.all.age[index] + '-'+(parseInt(reportAIData.all.age[index])+9) + '岁)'): (key + '年')}}</span>
                            <span v-html="UTILS.getBreakLineByText(allData)"></span>
                        </p>
                        <div class="report-result-mc-info pad-t-1">
                            <p class="report-p-blue">备注：大运就算是逆境，也会因为配合大运下面的年份(即流年)较好而发生质变，如果你目前所在的大运是逆境，那么要想更好的施展，除了寄希望于更好的年份出现，更加需要懂得趋吉避凶的方法。</p>
                            <p class="report-p-blue">系统会默认展示80年大运趋势，并不代表寿命只能活到80岁，能活过百岁的人将越来越多，跟时代发展及个人身心健康习惯、饮食作息习惯有直接关系。相同八字的人有长命百岁的，也有年轻夭折的，区别就在于后天的趋吉避凶是否踩准点了。所以说，易学八字是个很好的趋吉避凶的工具，但千万不可迷信宿命，毕竟事在人为。</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div id="titleBox5" class="report-result-content-title report-result-content-title-3">
            <p>八字属于概率学，虽不可能百分之百准确，但因积累数千年，其中的智慧依然会给每个人带来巨大参考价值。<span class="red2">智能测算属于知识付费，一旦付费不予退款，谢谢理解。</span></p>
        </div>

        <!-- <van-index-anchor class="van-index-anchor-report-result" index="更多科普" /> -->
        <div id="titleBox6" class="report-result-content-button">
            <div class="report-result-button-unlock" v-if="userData && parseInt(userData.vip) <= 20">
                <button class="report-rbul-button report-rbul-button-3" @click="clickVipButton">
                    <p class="report-rbul-button-p">终身会员免费解锁</p>
                    <p class="report-rbul-button-p">零基础八字及六爻入门课程</p>
                </button>
            </div>
            <div class="report-result-button-sub-text">
                <p>非专业人士谨记：科学用易学，切勿迷信之！</p>
                <p>专业人士谨记：科学传易学，顺时代之道，积口德，</p>
                <p>行善事，德蓄万物！</p>
            </div>
        </div>
        <!-- 6、更多科普 -->
        <div class="report-result-content" id="moreBox">
            <div class="report-result-title title-blue">更多科普</div>
            <div class="report-result-content-b1">
                <div class="report-result-content-b2">
                    <div class="report-result-detail pad-t-1">
                        <div class="report-result-detail-title">1、人的一生是不是注定的？</div>
                        <div class="report-result-detail-content">
                            <p><span class="blue">封建迷信：</span>人的贫富贵贱、财富级别、生老病死、感情婚姻生来注定<span class="iconbg icon-report-ji"></span></p>
                            <p><span class="blue">科学论证：</span>天下相同八字的人很多，但是大量案例已验证了这些人贫富级别很不相同、职业、婚姻、生儿育女都是不一样的；固定的是自然规律，但人的后天选择不同，就会决定结果不同；选对了适合的方向适合的行业，这个人就会相对较好；找对了配偶婚姻也会更加圆满，在不同的时代也会因为时空环境不一样，就算跟现代相同八字的人活的生命长度也不一样。所以，我们有必要了解一下八字的原理和规律，再适当采取趋吉避凶的方法来达成更好的结果，先人发明易学工具的目的就是帮助人类趋吉避凶<span class="iconbg icon-report-yi"></span></p>
                        </div>
                    </div>
                    <div class="report-result-detail pad-t-1">
                        <div class="report-result-detail-title">2、命运到底是什么？</div>
                        <div class="report-result-detail-content">
                            <p><span class="blue">封建迷信：</span>命运天定，人的一切已注定<span class="iconbg icon-report-ji"></span></p>
                            <p><span class="blue">科学论证：</span>命字拆开是口令的意思，说明世界有自然规则，地球以及人类遵循自然规则做运动；运是运行道路。命好比一辆车，出厂时会有些个体差异，运是自然规则，根据人出生的时间生成一条顺逆轨迹。虽然自然规则我们无法改变，但是我们能不能把人生这辆车打造得更好，选择更佳发展路径，这都是我们后天可以选择的，正因为这样，我们才会因此改变人生成就，而易学工具则是帮我们看清路途，帮助我们更平安更顺利的到达人生目的地。<span class="iconbg icon-report-yi"></span></p>
                        </div>
                    </div>
                    <div class="report-result-detail pad-t-1">
                        <div class="report-result-detail-title">3、命会不会越算越薄？</div>
                        <div class="report-result-detail-content">
                            <p><span class="blue">封建迷信：</span>命会越算越薄<span class="iconbg icon-report-ji"></span></p>
                            <p><span class="blue">科学论证：</span>我们反向思考一下，如果命会越算越簿的话，那易学工具将成为大杀器，算命师多的国家将会天下无敌；另外名人的八字基本上每天都被无数爱好者算上千万遍，如果真能有影响，那这些名人恐怕难以生存了。<span class="iconbg icon-report-yi"></span></p>
                        </div>
                    </div>
                    <div class="report-result-detail pad-t-1">
                        <div class="report-result-detail-title">4、八字让别人知道了是不是不好？</div>
                        <div class="report-result-detail-content">
                            <p><span class="blue">封建迷信：</span>不要轻易给别人看，会被算计<span class="iconbg icon-report-ji"></span></p>
                            <p><span class="blue">科学论证：</span>如果八字能被人利用做手脚的话，那不是跟古代扎小人的封建迷信一样的道理嘛。同上原理，八字让人知道并不会影响我们的人生轨迹，但是有的大师是有私心目的在，怕看的人多了，跟他说的不一致，可能会打脸很疼，另外，有些大师希望你只找他，不要再找别人，总之，只要我们举一反三细想一下就不会上当。<span class="iconbg icon-report-yi"></span></p>
                        </div>
                    </div>
                    <div class="report-result-detail pad-t-1">
                        <div class="report-result-detail-title">5、调风水是不是改变命运？</div>
                        <div class="report-result-detail-content">
                            <p><span class="blue">封建迷信：</span>调整风水可以发财致富<span class="iconbg icon-report-ji"></span></p>
                            <p><span class="blue">科学论证：</span>风水是我们所在环境的磁场能量，会对我们有影响，但是改变风水并不会改变命运，不会改变自然规则，更不会发生质变。如果风水改变能让我们的人生质变，试想一下，最先质变的是什么人？那不是风水大师们嘛。好的风水环境是可以为我们提供加分，但千万不要指望改变风水就能改变我们的命运，古人常说，福人居福地，最好的风水是我们的德行和心性。<span class="iconbg icon-report-yi"></span></p>
                        </div>
                    </div>
                    <div class="report-result-detail pad-t-1">
                        <div class="report-result-detail-title">6、世外高人是不是改变了命运，看八字就看不准了？</div>
                        <div class="report-result-detail-content">
                            <p><span class="blue">封建迷信：</span>高人改变了自己的命运，没人看得准<span class="iconbg icon-report-ji"></span></p>
                            <p><span class="blue">科学论证：</span>八字是根据出生时间各星球的位置关系生成的人生起伏规则，只要人生活在地球上就不可能改变这个规则；所以不可能有所谓的高人改变了命运，除非逃离地球，因为高人选择了避开红尘，生活范畴对应的事件就会跟普通人不一样，而且因为选择在一个独立的环境，那么能选择的输入也跟普通人不一样，同样是走好运或差运，自然表现的方式或者方面不一样，看上去一般人很难看准是什么那也很正常。但是并不会因为结果表现不同而去说明他们的命运已经改变。<span class="iconbg icon-report-yi"></span></p>
                        </div>
                    </div>
                    <div class="report-result-detail pad-t-1">
                        <div class="report-result-detail-title">7、给人看八字是不是泄露了天机？</div>
                        <div class="report-result-detail-content">
                            <p><span class="blue">封建迷信：</span>天机不可泄露，否则会有灾殃<span class="iconbg icon-report-ji"></span></p>
                            <p><span class="blue">科学论证：</span>天机是什么？天机是指自然界人们肉眼看不到的规则，所以像物理学里面讲的动力规则也是天机，人类的天气预报更是天机。其实，八字的预测更像天气预报，让人知道要下雨了得带伞，打雷了不要外出。人生运势不好就不要去跳坑，本质是一样的。天机你说不说，它都在那儿，关键在于你是用来做什么，如果是坑蒙拐骗，那肯定是会被收拾，如果是用来造福大众，本身并没有什么问题。<span class="iconbg icon-report-yi"></span></p>
                        </div>
                    </div>
                    <div class="report-result-detail pad-t-1">
                        <div class="report-result-detail-title">8、为什么江湖还有迷信说法不空出，不给钱算不准？</div>
                        <div class="report-result-detail-content">
                            <p><span class="blue">封建迷信：</span>法不空出，不给钱算不准<span class="iconbg icon-report-ji"></span></p>
                            <p><span class="blue">科学论证：</span>易学也好，西方占卜也好，也都只是一个预测工具，本身能不能算准，是个概率，跟看卦人的水平有关系。本身以此收费并没有问题，无可厚非，但是有些人只是为了以此来要挟求测人甚至找些玄幻的说法来恫吓敛财就显得有点居心不良，甚至有很多没口德胡说八道的大有人在，这都是历史遗毒，虽然他们说的不一定是对的，但确实会给求测人留下长期的心理阴影，这是我们坚决要打击铲除的。毕竟现在已经是科学时代了，那一套老的说辞在现代只会给易学这样的工具摸黑。希望从业的专业人士也致良知，摸着自己的良心去给人测算，真正能帮到他人才好，其实越真诚越能得到别人的打赏，这才是正道，才是长远之道。<span class="iconbg icon-report-yi"></span></p>
                        </div>
                    </div>
                    <div class="report-result-detail pad-t-1">
                        <div class="report-result-detail-title">9、怎么样健康改变命运结果？</div>
                        <div class="report-result-detail-content">
                            <p>知其然，知其所以然。要想改变人生的结果，首先得知道人与自然的运行原理及规则，八字这些易学工具是一个参考。然后要知道，是我们的性格意识决定行为，行为决定结果，所以要想在不好的运里改变产出结果，就需要回到底层性格意识上去做出改变，克服一些本能不好的意识，才能够治标治本，趋吉避凶。而不是找人算算，让人出个主意你就能听从改变的，要是这样能行的话，算命大师们不早就成为社会顶流了嘛？</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- </van-index-bar> -->
        <!-- 7、提示解锁成功的弹框 -->
        <van-popup class="report-result-suc" v-bind:value="showPaySuc" @click-overlay="clickPayPop">
            <div class="report-result-suc-content">
                <img v-bind:src="sucGif" alt="">
            </div>
        </van-popup>
    </div>
</template>

<script>
import { MIX, UTILS } from '../../modules/utils';
import ReportButton from './ReportButton.vue'
import ReportDataAreaNew from './ReportDataAreaNew.vue'
import NatureTalent from '../../layouts/nature/NatureTalent.vue'
import ReportRePayBar from './ReportRePayBar.vue';
import ReportInfo from './ReportInfo.vue';
import { SCHEME } from '../../modules/utils'
import { CONFIG } from '../../modules/config'
import { REPORT_DOM } from '../../modules/dom';
export default {
    name: 'ReportResult',
    props: {
        resultType: {
            type: String,
            default() { return '' }
        },
    },
    components: { ReportButton, ReportDataAreaNew, NatureTalent, ReportRePayBar, ReportInfo },
    computed: {
        fromEmbedded() {
            return this.$store.state.embedded.fromEmbedded;
        },
        userData() {
            return this.$store.state.userData ? this.$store.state.userData.info : {};
        },
        aiConfigData() {
            return this.$store.state.report.aiConfigData;
        },
        basicProductData() {
            return this.$store.state.report.aiConfigData.product;
        },
        reportProductData() {
            return this.$store.state.pay.reportProductData;
        },
        talentProductData() {
            return this.$store.state.pay.talentProductData;
        },
        productList() {
            return this.$store.state.report.productList;
        },
        productData() {
            return this.$store.state.report.productData;
        },
        reportData() {
            return this.$store.state.report.reportData;
        },
        reportAIData() {
            return this.$store.state.report.reportAIData;
        },
        showFreeCharacter() {
            return this.$store.state.report.showFreeCharacter;
        },
        reportMonthShowAll() {
            return this.$store.state.report.reportMonthShowAll;
        },
        reportMonthDataList() {
            return this.$store.state.report.reportMonthDataList;
        },
        reportMonthDataTotalList() {
            return this.$store.state.report.reportMonthDataTotalList;
        },
    },
    data() {
        return {
            UTILS: UTILS,
            monthXTitle: '(月)',
            fiveXTitle: '(年)',
            allXTitle: '(年)',
            monthXData: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
            monthYData: [130, 100, 150, 130, 150, 130, 100, 150, 130, 150, 100, 120],
            fiveXData: [2020, 2021, 2022, 2023, 2024],
            fiveYData: [130, 100, 150, 130, 150],
            allXData: [2020, 2030, 2040, 2050, 2060],
            allYData: [130, 100, 150, 130, 150],
            showPaySuc: false,
            sucGif: require('../../assets/images/report/report-suc.gif'),
            reportResultBarIndex: 0,
            reportResultBarList: ['性格天赋', '财富提升', '未来12月运', '未来5年运', '总运程', '更多科普'],
            payFailedStatus: {},
        }
    },
    mounted() {
        this.$bus.on('showReportSuc', this.showReportSuc);
    },
    destroyed() {
        this.$bus.off('showReportSuc', this.showReportSuc);
    },
    methods: {
        clickPay(params) {
            var me = this,
                reportId = this.reportData.id,
                detailInfo = this.$store.state.report.detailInfo;
            console.log('clickPay--------', params, params.free, params.data, reportId, detailInfo.id, this.fromEmbedded)
            switch(params.data.pid) {
                case 'pay_10000': //性格
                    MIX.trackButtonClicked('ai_unlock_character');
                    break;
                case 'pay_31100': //天赋
                    MIX.trackButtonClicked('ai_unlock_talent');
                    break;
                case 'pay_10001': //12个月
                    MIX.trackButtonClicked('ai_unlock_12_month');
                    break;
                case 'pay_10002': //提升财富
                    MIX.trackButtonClicked('ai_unlock_wealth_pattern');
                    break;
                case 'pay_10003': //5年
                    MIX.trackButtonClicked('ai_unlock_5_years');
                    break;
                case 'pay_10004': //总运程
                    MIX.trackButtonClicked('ai_unlock_all_life');
                    break;
                case 'pay_10005': //一键解锁
                    MIX.trackButtonClicked('ai_one_click_unlock');
                    break;
                default:
                    break;
            }
            
            // 免费解锁性格
            if(params.free && (this.aiConfigData.freeTimes > 0 || this.showFreeCharacter)) {
                this.$store.dispatch('report/useReportFree', {
                    id: detailInfo.id,
                    cb: params.cb ? params.cb : null
                });
                return;
            }
        
            // vip特权免费解锁
            if(this.userData && this.userData.vip > 10) {
                this.$store.dispatch('report/freeUnlockReport', {
                    detailInfo: detailInfo,
                    frompage: 'report',
                    failCb: function() {
                        this.$toast('免费解锁失败，请稍后再试');
                    }
                });
                return;
            }

            if(this.fromEmbedded) {
                SCHEME.createAppOrder(params.data.pid, detailInfo.id);
                // 支付成功和失败的回调:::app端的回调函数
                window.appFunc = {};
                window.appFunc.reportPaySucCb = function(data) {
                    console.log('reportPaySucCb::::::::', data)
                    // data = JSON.stringify(data);
                    if(detailInfo) {
                        me.$store.dispatch('report/updateReportInfo', data.baziId);
                    }
                    me.showReportSuc();
                    if(params.cb && typeof(params.cb) == 'function') {
                        params.cb();
                    }
                }
                window.appFunc.reportPayFailCb = function() {
                    if(params.cb && typeof(params.cb) == 'function') {
                        params.cb();
                    }
                }
                return;
            }

            if(CONFIG.platform == 'qq') {
                this.$store.state.pay.showDownloadPop = true;
                return;
            }

            var payType = CONFIG.platform == 'qq' ? 'wx_qr' : params.data.payType[2];
            this.$store.dispatch('pay/createPayOrder', {
                params: {
                    pid: params.data.pid,              //支付项目id
                    ptype: payType,                    //支付方式
                    ext: detailInfo.id                 //支付的评测id
                },
                mixParams: {
                    pid: params.data.pid,
                    product_name: params.data.title,
                    price: params.data.price,
                    from: 'generate_ai',
                },
                sucCb: function() {
                    console.log('支付成功，更新测评报告数据');
                    // 更新测验报告数据
                    if(detailInfo) {
                        me.$store.dispatch('report/updateReportInfo', detailInfo.id);
                    }
                    // 更新ai状态
                    me.$store.state.detail.personInfo.ai = 1;
                    me.$store.dispatch('record/updateRecordListAIStatus', {
                        id: detailInfo.id
                    });

                    me.showReportSuc();
                    if(params.cb && typeof(params.cb) == 'function') {
                        params.cb();
                    }
                },
                failCb: function() {
                    // 支付失败显示长蒙版
                    setTimeout(() => {
                        me.clickPayFailed(params.data);
                    }, 20);
                    
                    if(params.cb && typeof(params.cb) == 'function') {
                        params.cb();
                    }
                }
            });
        },
        clickPayFailed(data) {
            this.$set(this.payFailedStatus, data.pid, true);
        },
        clickPayPop() {
            this.showPaySuc = false;
        },
        showReportSuc() {
            // 显示并定时隐藏支付成功提示
            this.showPaySuc = true;
            setTimeout(() => {
                this.showPaySuc = false;
                REPORT_DOM.initReportPageHeightList();
                setTimeout(() => {
                    REPORT_DOM.bindReportScrollEvent();
                }, 20);
            }, 3000);
        },
        clickVipButton() {
            this.$store.dispatch('user/showMyVipPop', {vip: 30, frompage: 'report_mid'});
            setTimeout(() => {
                this.$bus.emit('initMyVipPage');
            }, 20);
        },
        onReportBarSelected(barText) {
            this.reportResultBarIndex = this.reportResultBarList.indexOf(barText);
        },
        updateMonthContent() {
            this.$store.dispatch('report/updateReportMonthDataStatus');
        },
        clickReportMonthDataFunc(params) {
            this.$store.dispatch('report/updateReportMonthDataListStatus', {index: params.index})
        }
    }
}
</script>